<template>
  <div>
    <v-card class="top-row py-2 px-3" elevation="2">
      <div>
        <v-text-field
          class="search-field"
          label="Sök efter sida"
          prepend-inner-icon="mdi-magnify"
          clearable
          elevation="2"
          outlined
          hide-details="true"
          dense
          @input="onSearch"
          :value="searchTerm"
        >
        </v-text-field>
        <div class="filters mt-2">
          <v-checkbox dense hide-details v-model="showOffline" label="Visa offline"></v-checkbox>
          <v-checkbox dense hide-details v-model="showRemoved" label="Visa borttagna"></v-checkbox>
        </div>
      </div>

      <v-btn size="large" color="primary" :to="{ name: 'createPage' }"> Skapa sida </v-btn>
    </v-card>

    <component :is="tableComponent" class="mt-3" :items="pages" :loading="loading" @page:goto="onPageGoto" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LatestPages from '../../components/pages/LatestPages'
import LatestPagesHavsutsikt from '../../components/pages/LatestPagesHavsutsikt'

let debounce = null

export default {
  name: 'PageList',
  props: {
    pages: { type: Array },
    section: { type: String },
    loading: { type: Boolean },
  },

  computed: {
    ...mapGetters('pages', ['getFilters', 'getFiltersByKey']),
    tableComponent() {
      switch (this.section) {
        case 'havsutsikt':
          return LatestPagesHavsutsikt
        default:
          return LatestPages;
      }
    },
    searchTerm() {
      return this.getFilters.find((f) => f.key === 'page_menu_title')?.value || ''
    },
    showOffline: {
      get() {
        const f = this.getFilters.find((f) => f.key === 'page_publish')
        if (f) {
          return f.value.includes('offline')
        }
        return []
      },
      set(isChecked) {
        let { value } = this.getFilters.find((f) => f.key === 'page_publish')
        value = isChecked ? [...value, 'offline'] : value.filter((v) => v !== 'offline')
        this.$emit('page:addFilter', { key: 'page_publish', value })
      },
    },
    showRemoved: {
      get() {
        const f = this.getFilters.find((f) => f.key === 'page_publish')
        if (f) {
          return f.value.includes('removed')
        }
        return []
      },
      set(isChecked) {
        let { value } = this.getFilters.find((f) => f.key === 'page_publish')
        value = isChecked ? [...value, 'removed'] : value.filter((v) => v !== 'removed')
        this.$emit('page:addFilter', { key: 'page_publish', value })
      },
    },
  },
  methods: {
     onSearch(val) {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
        this.$emit('page:search', val)
      }, 600)
    },
    onPageGoto({ id }) {
      this.$router.push({ name: 'Page', params: { id, section: this.section } })
    },
  },
}
</script>

<style lang="less" scoped>
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .filters {
    display: flex;
    gap: 10px;
  }
  .search-field {
    max-width: 400px;
  }
}
</style>
